import { regEmail } from '@constants';

export function isUserMobile() {
  const ua = navigator?.userAgent?.toLowerCase();
  return /mobile|android|iphone|ipod|phone|ipad/i.test(ua);
}

export function isEmail(email) {
  return regEmail.test(email);
}

export const isOnlyNumber = (number) => {
  const reg = /^\d*$/;
  return reg.test(number);
};

// 验证value是否为长度5-30，除了字母数字和下划线”_“，横杠”-”之外，其他特殊字符不可以
export const isValiate = (value) => {
  if (/^[a-zA-Z][a-zA-Z0-9-_]{4,29}$/.test(value)) {
    return true;
  }
  return false;
};

/**
 * 判断files1和files2是否相同
 * @param {*} files1 当前上传文件
 * @param {*} files2 之前上传文件
 * @returns 相同 true  不相同false
 */
export const compareFiles = (files1 = [], files2 = []) => {
  if (files1.length !== files2.length) {
    return false;
  }
  const IDs = files1.map((item) => item.id);
  return !files2.find((file) => !IDs.includes(file.id));
};

/**
 *
 * @param {String} value trackNumber
 * @returns {Boolean} 简单校验trackNumber是否符合要求
 */
export const trackNumberTest = (value) => /^(?=.*[0-9])[a-zA-Z0-9\s]+$/.test(value);
